export function clone(instance){
  return JSON.parse(JSON.stringify(instance));
}
